export const MAX_FILE_SIZE = 1000000000; // 2MB